$(function () {

    if ($('.site_flexible_content__flex_item .image_slider').length < 1) {
        return
    }

    // Append slider controls
    var flexSliderPrev = '<button class="button button--grey previous"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" /></svg></button>';
    var flexSliderNext = '<button class="button button--grey next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" /></svg></button>';
    var flexSliderControlsWrapper = '<div class="image_slider__controls"></div>';

    $('.site_flexible_content__flex_item .image_slider').append(flexSliderControlsWrapper);
    $('.image_slider__controls').append(flexSliderPrev);
    $('.image_slider__controls').append(flexSliderNext);

    // Remove class(es) when JS is enabled
    $('.site_flexible_content__flex_item .image_slider').removeClass('image_slider--no-js');

    // Initialise the image slider
    var flexImageSlider = tns({

        container: '.image_slider__slide_wrap',
        items: 1,
        autoplay: true,
        autoplayButtonOutput: false,
        autoplayTimeout: 7000,
        speed: 1000,
        loop: true,
        nav: true,
        navPosition: 'bottom',
        mouseDrag: false,
        arrowKeys: false,
        touch: true,
        controls: true,
        controlsContainer: '.image_slider__controls',
        preventActionWhenRunning: true,

    });


});